// extracted by mini-css-extract-plugin
export default {"root":"NoInvoiceResults_root__KGyw8","content":"NoInvoiceResults_content__N1EIx","message":"NoInvoiceResults_message__rKQ5v"};